import { useState } from 'react'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import classes from './index.module.scss'
import { Indicator } from './Indicator'

export const GroupIndicators = ({ financialType, indicators }) => {
  const [isOpen, setIsOpen] = useState(true)

  const toggleOpen = () => {
    setIsOpen((prev) => !prev)
  }

  return (
    <Element>
      <Element className={classes.groupIndicator} onClick={toggleOpen}>
        <Element className="fw600">
          <Translate value={`screening.${financialType}`} />
        </Element>
        <Element>
          <Icon
            className={`${isOpen ? 'icon-caret-bottom' : 'icon-caret-right'}`}
            style={{
              color: '#3A414B',
              fontSize: 8,
            }}
          />
        </Element>
      </Element>

      {isOpen && (
        <Element>
          {indicators.map((indicator) => (
            <Indicator
              key={indicator.screeningIndicatorId}
              indicator={indicator}
            />
          ))}
        </Element>
      )}
    </Element>
  )
}
